// removed by extract-text-webpack-plugin
module.exports = {"content":"CoreLayout__content___1xLqq","primary":"CoreLayout__primary___2ibE0","bottom":"CoreLayout__bottom___1UQFO","sticky-gateway":"CoreLayout__sticky-gateway___KTNmo","feedback":"CoreLayout__feedback___3AYft"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/CoreLayout/CoreLayout.scss
// module id = 1273
// module chunks = 1